import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from 'atoms/Modal';
import Button from 'atoms/Button';
import { AppDispatch } from 'store';
import { changeLanguage, closeModal, LanguageType } from 'store/layoutSlice';

const LANGUAGES: { code: LanguageType; flag: string; name: string }[] = [
    { code: 'en', flag: '🇬🇧', name: 'English' },
    { code: 'pl', flag: '🇵🇱', name: 'Polski' },
];

export const LanguageModal = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { t, i18n } = useTranslation();

    const handleClose = () => {
        dispatch(closeModal({ name: 'language' }));
    };

    const handleSelect = (code: LanguageType) => {
        localStorage.setItem('hustleLanguage', code);
        i18n.changeLanguage(code);
        dispatch(changeLanguage(code));
        handleClose();
    };

    return (
        <Modal open={true} size="s" onClose={handleClose}>
            <header>
                <h2>{t('TOPBAR.CHOOSE_LANGUAGE')}</h2>
            </header>
            <main style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {LANGUAGES.map(({ code, flag, name }) => (
                    <Button
                        key={code}
                        theme={i18n.language === code ? 'plain' : 'blank'}
                        align="left"
                        onClick={() => handleSelect(code)}
                    >
                        <span style={{ fontSize: '20px', lineHeight: 1 }}>{flag}</span>
                        <span>{name}</span>
                    </Button>
                ))}
            </main>
            <footer>
                <Button theme="plain" onClick={handleClose}>
                    <span>{t('TOPBAR.CLOSE')}</span>
                </Button>
            </footer>
        </Modal>
    );
};
